module.exports = __webpack_public_path__ + "9af56a1f461446bd942cc6d098af2998.png";